import { createElement, useEffect, useState } from 'react';

// Design System
import Input from 'jl-design-system/elements/input/Input';

// Types
import { ProgressStateType } from 'types/Constants.types';
import { InputWithProgressProps } from './InputWithProgress.types';

// Config
import PROGRESS_STATE from '@constants/progressStateConstants';

// Components
import Container from '@components/container';
import CircleLoader from '@widgets/circle-loader';

// Styles
import styles from './input-with-loading.scss';

const { FAILED, NONE } = PROGRESS_STATE;

const InputWithProgress = ({
  inputElement: InputElement = Input,
  progress = NONE,
  ...props
}: InputWithProgressProps) => {
  const [currentProgress, setCurrentProgress] = useState<ProgressStateType>(progress);

  useEffect(() => {
    setCurrentProgress(progress !== FAILED ? progress : NONE);
  }, [progress]);

  return (
    <Container className={currentProgress !== NONE && styles.padding} relative>
      {InputElement ? createElement(InputElement, { ...props }) : <Input {...props} />}
      <CircleLoader className={styles.spinner} progress={currentProgress} />
    </Container>
  );
};

export default InputWithProgress;
